import { render, staticRenderFns } from "./CompanyBranches.vue?vue&type=template&id=a1896f02&scoped=true&"
import script from "./CompanyBranches.vue?vue&type=script&lang=js&"
export * from "./CompanyBranches.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBranches.vue?vue&type=style&index=0&id=a1896f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1896f02",
  null
  
)

export default component.exports